var $74dd3f417665b06f$exports = {};
$74dd3f417665b06f$exports = {
    "loading": `Laden...`,
    "placeholder": `Selecteren\u{2026}`
};


export {$74dd3f417665b06f$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
